export enum UserInterfaceMode {
    Classic = 'Classic',
    Slim = 'Slim'
}
